/**
 * Decorative gradient rule that fills the space beside a section heading —
 * the BTK "Featured" row treatment, lifted out of the theme's PillarStack so
 * every section can share one implementation.
 *
 * <p>It is presentational only ({@code aria-hidden}) and stretches with
 * {@code flex: 1}, so inside {@link SectionShell}'s flex header it eats the
 * gap between the title and any trailing action. Hidden on phones, where the
 * heading already spans the full width and the rule would just add noise.
 *
 * <p>Consumers that render their own header markup (TestimonialsBento,
 * Podcasts, ActivityRow, the portal's ProfileStats) drop this straight into
 * their header row; blocks built on {@link SectionShell} get it from the
 * {@code headingLine} prop instead.
 */
export const HEADING_LINE_CLASS = 'sb-heading-line';

const headingLineCss = `
.${HEADING_LINE_CLASS} {
  flex: 1;
  height: 1px;
  min-width: 24px;
  margin-bottom: 6px;
  background: linear-gradient(to right,
    var(--color-border-default, rgba(255, 255, 255, 0.18)), transparent);
}
@media (max-width: 560px) {
  .${HEADING_LINE_CLASS} { display: none; }
}
`;

export function HeadingLine() {
  return (
    <>
      <div className={HEADING_LINE_CLASS} aria-hidden />
      <style dangerouslySetInnerHTML={{ __html: headingLineCss }} />
    </>
  );
}
